import type { ApiCourseCategory, ApiCourseListItem, ApiCourseDetail } from '../types/course'
import { authFetch } from '@/services/apiClient'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5050/api'

interface ApiResponse<T> {
  success: boolean
  data: T
  error?: string
}

export const getCourseCategories = async (): Promise<ApiCourseCategory[]> => {
  const res = await fetch(`${API_URL}/course-categories`)
  const json: ApiResponse<ApiCourseCategory[]> = await res.json()
  if (!json.success) throw new Error(json.error || 'โหลดหมวดหมู่ไม่สำเร็จ')
  return json.data
}

export const getCourses = async (params: { category_id?: number; search?: string } = {}): Promise<ApiCourseListItem[]> => {
  const query = new URLSearchParams()
  if (params.category_id) query.append('category_id', String(params.category_id))
  if (params.search) query.append('search', params.search)
  const qs = query.toString()
  const res = await fetch(`${API_URL}/courses${qs ? `?${qs}` : ''}`)
  const json: ApiResponse<ApiCourseListItem[]> = await res.json()
  if (!json.success) throw new Error(json.error || 'โหลดคอร์สไม่สำเร็จ')
  return json.data
}

// ลิงก์ดูวิดีโอบทเรียน (ต้อง login + ลงทะเบียนคอร์สนี้แล้ว หรือเป็นบทเรียนตัวอย่าง)
// FILE = ไฟล์ที่อัปโหลด (presigned URL อายุสั้น เล่นใน <video> ได้) · LINK = ลิงก์เก่า (เช่น YouTube) ที่ยังไม่ได้เปลี่ยนเป็นไฟล์
export interface LessonVideo {
  kind: 'FILE' | 'LINK'
  url: string
}

export const getLessonVideo = async (lessonId: number): Promise<LessonVideo> => {
  const res = await authFetch(`/lessons/${lessonId}/video`)
  const json: ApiResponse<LessonVideo> = await res.json().catch(() => ({ success: false, error: 'โหลดวิดีโอไม่สำเร็จ' } as ApiResponse<LessonVideo>))
  if (!json.success || !json.data) throw new Error(json.error || 'โหลดวิดีโอไม่สำเร็จ')
  return json.data
}

// ดูตัวอย่างฟรี — ไม่ต้องล็อกอิน (วิดีโอแนะนำคอร์ส / บทเรียนที่เปิด Preview)
const fetchPreview = async (path: string): Promise<LessonVideo> => {
  const res = await fetch(`${API_URL}${path}`)
  const json: ApiResponse<LessonVideo> = await res.json().catch(() => ({ success: false, error: 'โหลดวิดีโอตัวอย่างไม่สำเร็จ' } as ApiResponse<LessonVideo>))
  if (!json.success || !json.data) throw new Error(json.error || 'โหลดวิดีโอตัวอย่างไม่สำเร็จ')
  return json.data
}
export const getCoursePreviewVideo = (courseId: number) => fetchPreview(`/courses/${courseId}/preview-video`)
export const getLessonPreviewVideo = (lessonId: number) => fetchPreview(`/lessons/${lessonId}/preview-video`)

export const getCourseBySlug = async (slug: string): Promise<ApiCourseDetail> => {
  const res = await fetch(`${API_URL}/courses/${slug}`)
  const json: ApiResponse<ApiCourseDetail> = await res.json()
  if (!json.success) throw new Error(json.error || 'ไม่พบคอร์สนี้')
  return json.data
}

// enum ทุกตัวในระบบ (ทุก domain) — scan มาจาก con_sqlalchemy.py ฝั่ง backend อัตโนมัติ
// ห้าม hardcode ค่า enum (เช่น level, status) ไว้ในฝั่ง frontend เด็ดขาด ให้ดึงจากตรงนี้เสมอ
export const getEnums = async (): Promise<Record<string, string[]>> => {
  const res = await fetch(`${API_URL}/enums`)
  const json: ApiResponse<Record<string, string[]>> = await res.json()
  if (!json.success) throw new Error(json.error || 'โหลด enums ไม่สำเร็จ')
  return json.data
}
